import React, { Component } from 'react';
import PropTypes from 'prop-types';
import style from './style/rozet.scss';


/**
 * Rozet
 *
 * @example (with just one slice filled in)
 *
 * <Rozet
 *     <defs id="path-definitions">
 *         <clipPath id="ring-clip-zij-1aanpa">
 *             <path d="M250,250 L146,0 L353,0 Z"></path>
 *         </clipPath>
 *         <path id="text-concave" d="M48,333 A219,219 0 1,1 452,333"></path>
 *         <path id="text-convex" d="M36,338 A231,231 0 0,0 464,338"></path>
 *     </defs>
 *     <g id="ring">
 *         <g>
 *             <circle cx="250" cy="250" r="250" style="clip-path: url(&quot;#ring-clip-zij-1aanpa&quot;);"></circle>
 *             <text dx="368.75"><textPath xlink:href="#text-concave">outer ring text</textPath></text>
 *         </g>
 *     </g>
 *     <g>
 *         <circle fill="#fff" cx="250" cy="250" r="205"></circle>
 *     </g>
 *     <g id="score">
 *         <circle cx="250" cy="250" r="44" style="clip-path: url(&quot;#ring-clip-zij-1aanpa&quot;);"></circle>
 *     </g>
 * />
 */
export default class Rozet extends Component {
    render() {
        const { classes, children } = this.props;

        return (
            <section className={ style.rozet } style={ classes.root } >
                <figure>
                    <div>
                        <svg
                            className={ style.rozetSvg }
                            style={ classes.svg }
                            viewBox="0 0 600 600"
                            width="100%"
                            height="100%"
                            preserveAspectRatio="xMidYMin slice"
                        >
                            { children }
                        </svg>
                    </div>
                </figure>
            </section>
        );
    }
}

Rozet.propTypes = {
    classes: PropTypes.object,
    children: PropTypes.array
};

Rozet.defaultProps = {
    classes: {},
    children: []
};
